import React from 'react'

export const AdminWholesellersPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-neutral-200-100">
      <div className="max-w-md p-8 bg-background rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">Subscriptions Management</h2>
        <p className="text-gray-600">Coming Soon</p>
      </div>
    </div>
  )
}

export default AdminWholesellersPage
